import type { ReactElement } from 'react';

import type { PopoverTriggerProps } from '@opendoor/atoms/popover';

export const MARKETPLACE_POPOVER_SURFACE_CLASS =
  'max-w-[calc(100vw-2rem)] ring-1 ring-od-border-primary';

export type PopoverTriggerRender = Exclude<
  NonNullable<PopoverTriggerProps['render']>,
  ReactElement
>;
